import type { IAddonProductConstructorParams } from "@services/sdk";
import { map } from "ramda";
import AddonProduct from "./addon-product";

class BoosterProduct extends AddonProduct {
	public static ConstructList(
		arrParams: Array<IAddonProductConstructorParams>,
	): Array<BoosterProduct> {
		return map(BoosterProduct.Construct)(arrParams);
	}

	public static Construct(
		params: IAddonProductConstructorParams,
	): BoosterProduct {
		return new BoosterProduct(params);
	}

	responseData: IAddonProductConstructorParams;

	constructor(params: IAddonProductConstructorParams) {
		super(params);
		this.responseData = params;
	}
}

export default BoosterProduct;
